import { render, staticRenderFns } from "./Metadata.vue?vue&type=template&id=e7def4e4&scoped=true&"
import script from "./Metadata.vue?vue&type=script&lang=js&"
export * from "./Metadata.vue?vue&type=script&lang=js&"
import style0 from "./Metadata.vue?vue&type=style&index=0&id=e7def4e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7def4e4",
  null
  
)

export default component.exports